/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
    DELETE_ASSET_SUCCESS,
    DELETE_ASSET_FAILURE,
} from '../actions/asset/assetActionTypes';

export default function (state = {}, action) {
    switch (action.type) {
        case DELETE_ASSET_SUCCESS:
        return {
            deletingSuccess: true
        }
        case DELETE_ASSET_FAILURE:
        return {
            deletingSuccess: false
        }
        default:
            return state;
    }
}